export const ORG_DEFAULT_COLOR = '#616161'
